import React from 'react'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import Button from '../../components/Button'

const ButtonGroupExt = (props) => {
  const inputFreeze = useSelector((state) => state.calculation.input.inputFreeze)
  const { buttonGroupClass, buttonClass, colClass, name, value, options, handleButtonClick, containerProps } = props

  const handleClick = (e, targetValue) => {
    e.preventDefault()
    e.stopPropagation()
    if (targetValue === value) {
      return
    }
    handleButtonClick(name, targetValue)
  }

  const bgClass = buttonGroupClass ? (' ' + buttonGroupClass) : ''
  const bClass = buttonClass ? (' ' + buttonClass) : ''
  const cClass = colClass ? (' ' + colClass) : ''

  return (
    <div className={"buttonGroup row -skinny" + bgClass} label="">
      {
        options.map((item, index) => {
          const checked = (item.value === value || item.alternativeValue === value) ? ' -checked' : ''
          return (
            <div className={colClass} key={item.value} {...containerProps}>
              <Button type="button" variant="subAppSelector" value={item.value} className={'button' + bClass + checked} disabled={inputFreeze} onClick={(e) => handleClick(e, item.value)}>
                {item.imgSrc ? <img className="illustration" src={item.imgSrc} alt={`${item.value} illustration`} /> : null}
                {item.largeText ? (
                  <div className="button__largeText">{ReactHtmlParser(item.largeText)}</div>
                ) : null}
                {item.text ? <div className="button__text">{item.text}</div> : null}
              </Button>
            </div>
          )
        })
      }
    </div>
  )
}
export default ButtonGroupExt
